import { Box, Fade, Modal, Stack, Typography } from "@mui/material";
// import Image from "next/image";
import React, { useEffect } from 'react';
import closeIcon from "../../assets/images/close.svg";
import { getMethod } from "../../services/apiService";
import { clearStorageAndCookies } from "../../services/authService";
import { useNavigate } from 'react-router-dom';

const styleModal = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "420px",
    backgroundColor: "#1D292E",
    borderRadius: "8px",
    padding: "24px",
    boxShadow: "2px 2px 20px 2px #FFFFFF14"
};


export const LogoutModal = (props: any) => {
    const navigate = useNavigate();
    
    const handleLogout = async () => {
        const resp = await getMethod("central/user/auth/logout");
        if(resp?.data?.code === 200) {
            clearStorageAndCookies();
            props.setOpenLogoutModal(false);
            navigate("/login");
        }
      };

    return (
        <Modal
            open={props.openLogoutModal}
            //onClose={handleClose}
            closeAfterTransition
            BackdropProps={{ timeout: 5000 }}
            style={{backgroundColor: '#1f2f34'}}
        >
            <Fade in={props.openLogoutModal}>
                <Box sx={styleModal}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ color: '#E2E3E3', fontWeight: 500, fontSize: '20px' }}>
                            Unauthorized Access!
                        </Typography>
                    </Stack>
                    <Box sx={{ my: '16px', py: '16px', borderTop: '1px solid #313838' }}>
                        <Typography>You do not have permission to access this website!</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: '12px' }}>
                        <Box
                            sx={{minWidth: 70, textAlign: 'center', backgroundColor: '#17B2EB', padding: '12px', borderRadius: '30px', cursor: 'pointer', color: '#1E2121', fontSize: '14px', fontWeight: 500, margin:'0' }}
                            onClick={handleLogout}
                        >
                        Logout
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};
